// Top 150 US cities by population for local SEO targeting
export const top150USCities = [
  // Top 50
  { city: "New York", state: "NY" },
  { city: "Los Angeles", state: "CA" },
  { city: "Chicago", state: "IL" },
  { city: "Houston", state: "TX" },
  { city: "Phoenix", state: "AZ" },
  { city: "Philadelphia", state: "PA" },
  { city: "San Antonio", state: "TX" },
  { city: "San Diego", state: "CA" },
  { city: "Dallas", state: "TX" },
  { city: "San Jose", state: "CA" },
  { city: "Austin", state: "TX" },
  { city: "Jacksonville", state: "FL" },
  { city: "Fort Worth", state: "TX" },
  { city: "Columbus", state: "OH" },
  { city: "Indianapolis", state: "IN" },
  { city: "Charlotte", state: "NC" },
  { city: "San Francisco", state: "CA" },
  { city: "Seattle", state: "WA" },
  { city: "Denver", state: "CO" },
  { city: "Washington", state: "DC" },
  { city: "Nashville", state: "TN" },
  { city: "Oklahoma City", state: "OK" },
  { city: "El Paso", state: "TX" },
  { city: "Boston", state: "MA" },
  { city: "Portland", state: "OR" },
  { city: "Las Vegas", state: "NV" },
  { city: "Detroit", state: "MI" },
  { city: "Memphis", state: "TN" },
  { city: "Louisville", state: "KY" },
  { city: "Baltimore", state: "MD" },
  { city: "Milwaukee", state: "WI" },
  { city: "Albuquerque", state: "NM" },
  { city: "Tucson", state: "AZ" },
  { city: "Fresno", state: "CA" },
  { city: "Sacramento", state: "CA" },
  { city: "Kansas City", state: "MO" },
  { city: "Mesa", state: "AZ" },
  { city: "Atlanta", state: "GA" },
  { city: "Omaha", state: "NE" },
  { city: "Colorado Springs", state: "CO" },
  { city: "Raleigh", state: "NC" },
  { city: "Long Beach", state: "CA" },
  { city: "Virginia Beach", state: "VA" },
  { city: "Miami", state: "FL" },
  { city: "Oakland", state: "CA" },
  { city: "Minneapolis", state: "MN" },
  { city: "Tulsa", state: "OK" },
  { city: "Bakersfield", state: "CA" },
  { city: "Wichita", state: "KS" },
  { city: "Arlington", state: "TX" },
  // Cities 51-100
  { city: "Tampa", state: "FL" },
  { city: "Aurora", state: "CO" },
  { city: "New Orleans", state: "LA" },
  { city: "Anaheim", state: "CA" },
  { city: "Santa Ana", state: "CA" },
  { city: "St. Louis", state: "MO" },
  { city: "Riverside", state: "CA" },
  { city: "Corpus Christi", state: "TX" },
  { city: "Lexington", state: "KY" },
  { city: "Pittsburgh", state: "PA" },
  { city: "Stockton", state: "CA" },
  { city: "Anchorage", state: "AK" },
  { city: "Cincinnati", state: "OH" },
  { city: "Saint Paul", state: "MN" },
  { city: "Greensboro", state: "NC" },
  { city: "Toledo", state: "OH" },
  { city: "Newark", state: "NJ" },
  { city: "Plano", state: "TX" },
  { city: "Henderson", state: "NV" },
  { city: "Lincoln", state: "NE" },
  { city: "Orlando", state: "FL" },
  { city: "Buffalo", state: "NY" },
  { city: "Jersey City", state: "NJ" },
  { city: "Chula Vista", state: "CA" },
  { city: "Fort Wayne", state: "IN" },
  { city: "Chandler", state: "AZ" },
  { city: "St. Petersburg", state: "FL" },
  { city: "Laredo", state: "TX" },
  { city: "Durham", state: "NC" },
  { city: "Irvine", state: "CA" },
  { city: "Madison", state: "WI" },
  { city: "Norfolk", state: "VA" },
  { city: "Lubbock", state: "TX" },
  { city: "Gilbert", state: "AZ" },
  { city: "Winston-Salem", state: "NC" },
  { city: "Glendale", state: "AZ" },
  { city: "Reno", state: "NV" },
  { city: "Hialeah", state: "FL" },
  { city: "Garland", state: "TX" },
  { city: "Chesapeake", state: "VA" },
  { city: "Irving", state: "TX" },
  { city: "North Las Vegas", state: "NV" },
  { city: "Scottsdale", state: "AZ" },
  { city: "Baton Rouge", state: "LA" },
  { city: "Fremont", state: "CA" },
  { city: "Richmond", state: "VA" },
  { city: "Boise", state: "ID" },
  { city: "San Bernardino", state: "CA" },
  { city: "Birmingham", state: "AL" },
  // Cities 101-150
  { city: "Spokane", state: "WA" },
  { city: "Rochester", state: "NY" },
  { city: "Des Moines", state: "IA" },
  { city: "Modesto", state: "CA" },
  { city: "Fayetteville", state: "NC" },
  { city: "Tacoma", state: "WA" },
  { city: "Oxnard", state: "CA" },
  { city: "Fontana", state: "CA" },
  { city: "Columbus", state: "GA" },
  { city: "Montgomery", state: "AL" },
  { city: "Moreno Valley", state: "CA" },
  { city: "Shreveport", state: "LA" },
  { city: "Aurora", state: "IL" },
  { city: "Yonkers", state: "NY" },
  { city: "Akron", state: "OH" },
  { city: "Huntington Beach", state: "CA" },
  { city: "Little Rock", state: "AR" },
  { city: "Augusta", state: "GA" },
  { city: "Amarillo", state: "TX" },
  { city: "Glendale", state: "CA" },
  { city: "Mobile", state: "AL" },
  { city: "Grand Rapids", state: "MI" },
  { city: "Salt Lake City", state: "UT" },
  { city: "Tallahassee", state: "FL" },
  { city: "Huntsville", state: "AL" },
  { city: "Grand Prairie", state: "TX" },
  { city: "Knoxville", state: "TN" },
  { city: "Worcester", state: "MA" },
  { city: "Newport News", state: "VA" },
  { city: "Brownsville", state: "TX" },
  { city: "Overland Park", state: "KS" },
  { city: "Santa Clarita", state: "CA" },
  { city: "Providence", state: "RI" },
  { city: "Garden Grove", state: "CA" },
  { city: "Chattanooga", state: "TN" },
  { city: "Oceanside", state: "CA" },
  { city: "Jackson", state: "MS" },
  { city: "Fort Lauderdale", state: "FL" },
  { city: "Santa Rosa", state: "CA" },
  { city: "Rancho Cucamonga", state: "CA" },
  { city: "Port St. Lucie", state: "FL" },
  { city: "Tempe", state: "AZ" },
  { city: "Ontario", state: "CA" },
  { city: "Vancouver", state: "WA" },
  { city: "Cape Coral", state: "FL" },
  { city: "Sioux Falls", state: "SD" },
  { city: "Springfield", state: "MO" },
  { city: "Peoria", state: "AZ" },
  { city: "Pembroke Pines", state: "FL" },
  { city: "Elk Grove", state: "CA" },
];
